import React from 'react';

const IconPaymentMastercard: React.FC<JSX.IntrinsicElements['svg']> = (props) => (
  <svg width="38" height="24" viewBox="0 0 38 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="38" height="24" rx="2.03822" fill="black" />
    <rect x="15.3799" y="5.65045" width="7.28181" height="11.945" fill="#FF5F00" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1145 11.6229C16.115 9.29491 17.174 7.09491 18.9894 5.65045C15.8922 3.20146 11.4437 3.55744 8.77057 6.46818C6.09747 9.37892 6.09747 13.8669 8.77057 16.7777C11.4437 19.6884 15.8922 20.0444 18.9894 17.5954C17.174 16.151 16.115 13.951 16.1145 11.6229Z"
      fill="#EB001B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.2239 11.6229C31.2259 14.5298 29.577 17.1825 26.9778 18.4538C24.3785 19.7252 21.2855 19.3918 19.0132 17.5954C20.829 16.1513 21.8881 13.9511 21.8881 11.6229C21.8881 9.29477 20.829 7.09455 19.0132 5.65045C21.2855 3.85404 24.3785 3.52069 26.9778 4.79204C29.577 6.06339 31.2259 8.71609 31.2239 11.6229Z"
      fill="#F79E1B"
    />
  </svg>
);

export default IconPaymentMastercard;
